import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Lottie from "lottie-react";
import loginLottie from "../static/login-asset/wm-login-lottie.json";
import Logo from "./Logo";
import { AppConstants } from "../constants";

interface RedirectMessageLayoutProps {
  title: string;
  message: string;
  redirectMessage: string;
  redirectDelay: number;
  redirectPath: string;
}

const RedirectMessageLayout: React.FC<RedirectMessageLayoutProps> = ({
  title,
  message,
  redirectMessage,
  redirectDelay,
  redirectPath,
}) => {

  const navigate = useNavigate();
  // const basename = "/wmlogin";
  // Helper function to create full URLs for meta refresh
  // const createFullUrl = (path: string): string => {
  //   const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  //   return `${window.location.origin}${basename}${normalizedPath}`;
  // };

  const currentYear = new Date().getFullYear();

  useEffect(() => {
    // Setup redirect timer
    const timer = setTimeout(() => {
      navigate(redirectPath);
    }, redirectDelay);

    return () => clearTimeout(timer);
  }, [navigate, redirectPath, redirectDelay]);



  return (
    <div className="login-container">
      <div className="row">
        <div className="login-left-section col-xs-12 col-sm-5 col-md-5 col-lg-5">
          <div className="login-content">
            <Logo />
            <div className="form-container login">
              <div className="form-title">
                <h1>{title}</h1>
              </div>
              <div className="form-row">
                <div className="row">
                  <div className="col-sm-12">
                    <p className="redirect-message">{message}</p>
                    <p className="redirect-message">{redirectMessage}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <p className="copyright-text">
            © {currentYear} WaveMaker. All Rights Reserved
          </p>
        </div>
        <div className="login-right-section col-xs-12 col-sm-7 col-md-7 col-lg-7">
          <div className="right-content-wrapper">
            <h3 className="right-section-title">
              {AppConstants.CAROUSELTITLE}
            </h3>
            <Lottie
              animationData={loginLottie}
              loop={true}
              className="lottie-animation"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedirectMessageLayout;